import React from "react";
import './WhyUs.scss';
import lang from '../../i18/lang';

import img_kreativnost from "../../assets/icons/kreativnost.png";
import img_preciznost from "../../assets/icons/preciznost.png";
import img_brzina from "../../assets/icons/brzina.png";
import img_why from "../../assets/illustration/why.png";
import img_sigurnost from "../../assets/icons/sigurnost.png";
import img_garancija from "../../assets/icons/garancija.png";
import img_efikasnost from "../../assets/icons/efikasnost.png";

class WhyUs extends React.Component {
    render(){
        return (
            <div className="whyUs">
                <div className="whyUs-content">
                    <div className="whyUs-title">
                        <h1>{lang.srb.section.whyUs.title_start}<span className="red">{lang.srb.section.whyUs.title_end}</span></h1>
                    </div>
                    <div className="whyUs-body">
                        <div className="whyUs-item-wrapper whyUs-item-wrapper-left">
                            <div className="whyUs-item whyUs-item-left">
                                <div className="whyUs-item-content flex-align-right">
                                    <h4 className="align-right">{lang.srb.section.whyUs.kreativnost.title}</h4>
                                    <div className="whyUs-separator bg-yellow"></div>
                                    <div className="whyUs-item-text align-right">{lang.srb.section.whyUs.kreativnost.body}</div>
                                </div>
                                <div className="whyUs-item-icon">
                                    <img src={img_kreativnost} alt="..."/>
                                </div>
                            </div>
                            <div className="whyUs-item whyUs-item-left">
                                <div className="whyUs-item-content flex-align-right">
                                    <h4 className="align-right">{lang.srb.section.whyUs.preciznost.title}</h4>
                                    <div className="whyUs-separator bg-light-green"></div>
                                    <div className="whyUs-item-text align-right">{lang.srb.section.whyUs.preciznost.body}</div>
                                </div>
                                <div className="whyUs-item-icon">
                                    <img src={img_preciznost} alt="..."/>
                                </div>
                            </div>
                            <div className="whyUs-item whyUs-item-left">
                                <div className="whyUs-item-content flex-align-right">
                                    <h4 className="align-right">{lang.srb.section.whyUs.brzina.title}</h4>
                                    <div className="whyUs-separator bg-red"></div>
                                    <div className="whyUs-item-text align-right">{lang.srb.section.whyUs.brzina.body}</div>
                                </div>
                                <div className="whyUs-item-icon">
                                    <img src={img_brzina} alt="..."/>
                                </div>
                            </div>
                        </div>
                        <div className="whyUs-central-img">
                            <img src={img_why} alt=""/>
                        </div>
                        <div className="whyUs-item-wrapper whyUs-item-wrapper-right">
                            <div className="whyUs-item whyUs-item-right">
                                <div className="whyUs-item-icon">
                                    <img src={img_sigurnost} alt="..."/>
                                </div>
                                <div className="whyUs-item-content flex-align-left">
                                    <h4 className="align-left">{lang.srb.section.whyUs.sigurnost.title}</h4>
                                    <div className="whyUs-separator bg-red"></div>
                                    <div className="whyUs-item-text align-left">{lang.srb.section.whyUs.sigurnost.body}</div>
                                </div>
                            </div>
                            <div className="whyUs-item whyUs-item-right">
                                <div className="whyUs-item-icon">
                                    <img src={img_garancija} alt="..."/>
                                </div>
                                <div className="whyUs-item-content flex-align-left">
                                    <h4 className="align-left">{lang.srb.section.whyUs.garancija.title}</h4>
                                    <div className="whyUs-separator bg-light-green"></div>
                                    <div className="whyUs-item-text align-left">{lang.srb.section.whyUs.garancija.body}</div>
                                </div>
                            </div>
                            <div className="whyUs-item whyUs-item-right">
                                <div className="whyUs-item-icon">
                                    <img src={img_efikasnost} alt="..."/>
                                </div>
                                <div className="whyUs-item-content flex-align-left">
                                    <h4 className="align-left">{lang.srb.section.whyUs.efikasnost.title}</h4>
                                    <div className="whyUs-separator bg-yellow"></div>
                                    <div className="whyUs-item-text">{lang.srb.section.whyUs.efikasnost.body}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default WhyUs;